import { useQuery } from '@tanstack/react-query';
import { listUsers } from '@/api/entities/users';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';

type QueryFnType = typeof listUsers;

type UseUsersOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useUsers = ({ config }: UseUsersOptions = {}) => {
  const { getAccessToken, isAuthenticated, isLoading: authLoading } = useCognitoAuth();

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['users'],
    queryFn: () => listUsers(getAccessToken),
    enabled: isAuthenticated && !authLoading && config?.enabled !== false,
  });
};
